<div class="holder {{ isScreenLandscape }}">
  <section class="head">
    <div class="text-and-action-button-holder">
      <h1>Burada Herkes<br />Kazanır</h1>
      <h2>
        Kullanıcılar fikirlerini paylaşarak ödüller kazanır;<br />
        markalar ise doğru verilerle güçlenir ve Bilgesin<br />
        topluluğundan yeni müşteriler edinir.
      </h2>
      <app-button
        type="home-colt"
        text="Bilgesin'i Keşfet"
        (click)="navigateToLogin()"
        class="nav-to-campaign-button"
      ></app-button>
    </div>
    <div class="image-holder">
      <img src="../../../assets/images/home-image.png" alt="" />
    </div>
  </section>
  <section class="home-seperator">
    <img src="../../../assets/images/section-background.svg" alt="" />
  </section>
  <section class="mid" id="campaigns-section">
    <div class="content" id="campaigns-section-content">
      <app-bize-guvenenler-owl
        [data]="bizeGuvenenlerItems"
      ></app-bize-guvenenler-owl>
      <h2 class="flowchart-container-title">Nasıl Çalışır?</h2>
      <div class="flowchart-container">
        <div class="flowchart-item">
          <div class="flowchart-item--img">
            <img src="/assets/images/flow-chart/1.png" />
          </div>
          <h3 class="flowchart-item--title">Kullanıcı & Marka Buluşması</h3>
          <span class="flowchart-item--text">
            İş ortağı markalar, yaklaşık 1 dakika süren kısa anketlerle Bilgesin
            kullanıcıları ile etkileşime geçer.
          </span>
        </div>
        <div class="flowchart-arrow">
          <img src="/assets/images/flow-chart/right-arrow.png" />
        </div>
        <div class="flowchart-item">
          <div class="flowchart-item--img">
            <img src="/assets/images/flow-chart/2.png" />
          </div>
          <h3 class="flowchart-item--title">Kullanıcı ne kazanır?</h3>
          <span class="flowchart-item--text">
            Kullanıcılar sevdikleri markaların araştırmalarına katılarak, ek
            indirim/hediye kodları kazanır. Bu kodları, araştırmasına
            katıldıkları markanın online alışveriş kanallarında veya fiziksel
            satış noktalarında kullanabilirler.
          </span>
        </div>
        <div class="flowchart-arrow">
          <img src="/assets/images/flow-chart/right-arrow.png" />
        </div>
        <div class="flowchart-item">
          <div class="flowchart-item--img">
            <img src="/assets/images/flow-chart/3.png" />
          </div>
          <h3 class="flowchart-item--title">Marka ne kazanır?</h3>
          <span class="flowchart-item--text">
            Gerçek kullanıcı verilerini anlık olarak izleyen markalar, hem hedef
            kitlesini daha iyi tanır hem de Bilgesin üye havuzu içinden yeni
            müşteriler kazanır.
          </span>
        </div>
      </div>

      <ng-template [ngIf]="false">
        <ul class="tabs" id="campaigns-tabs">
          <li
            *ngFor="let item of tabs"
            [class.active]="item.active"
            (click)="changeTab(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- <div class="search-area">
    <input type="text" placeholder="Kampanya / Firma Adı İle Ara" [(ngModel)]="filterText" />
    <img class="search-icon" src="../../../assets/images/search-icon.svg" alt="" />
  </div> -->
        <div class="search-filter-area" *ngIf="filters">
          <div class="form-control-holder">
            <select [(ngModel)]="filterSector">
              <option value="">Sektör Seçiniz</option>
              <option
                *ngFor="let item of filters.sectors"
                [value]="item._id"
                [disabled]="item.campaignCount <= 0"
              >
                {{ item.name }}
                {{ item.campaignCount <= 0 ? "(Kampanya sona erdi)" : "" }}
              </option>
            </select>
          </div>
          <!-- <div class="form-control-holder">
      <select [(ngModel)]="filterCity">
        <option value="">İl Seçiniz</option>
        <option *ngFor="let item of filters.cities" [value]="item.name">
          {{ item.name }}
        </option>
      </select>
    </div>
    <div class="form-control-holder">
      <select [(ngModel)]="filterTown" [disabled]="!filterCity">
        <option value="">İlçe Seçiniz</option>
        <option *ngFor="let item of filtersTowns" [value]="item.name">
          {{ item.name }}
        </option>
      </select>
    </div> -->
        </div>
        <div class="results-area">
          <ul>
            <li
              *ngFor="let item of campaigns"
              [routerLink]="generateCampaignSlugUrl(item)"
            >
              <div class="logo-holder">
                <div
                  class="campaign-logo-bg"
                  *ngIf="item.logo"
                  style="background-image: url('{{ item.logo }}')"
                ></div>
                <div
                  class="campaign-logo-bg"
                  *ngIf="!item.logo"
                  style="
                    background-image: url('../../../assets/images/logo-dark.svg');
                  "
                ></div>
              </div>
              <div class="content-holder">
                <div class="cta-top">
                  {{ item.sectorName }} <br />
                  {{ cityTownName(item) }}
                </div>
                <span
                  ><b>{{ item.name }}</b></span
                >
                <div class="cta-holder">
                  <app-button
                    type="simple"
                    text="Kazanmaya Başla!"
                  ></app-button>
                </div>
              </div>
              <div class="discount-holder">
                <app-button
                  *ngIf="item.discountType !== 'Hediye'"
                  type="curvy"
                  text="{{ item.discountAmount }} {{
                    item.discountAmountType
                  }} indirim"
                ></app-button>
                <app-button
                  *ngIf="item.discountType === 'Hediye'"
                  [type]="getGiftFontClass(item)"
                  text="{{ item.discountDescription?.trim() }}"
                ></app-button>
                <span
                  class="last-date-text"
                  *ngIf="item.campaignExpireDateTime"
                >
                  Son Katılım
                  {{ item.campaignExpireDateTime | date : "dd.MM.yyyy" }}
                </span>
                <span class="last-date-text" style="font-weight: normal">
                  Ayrıntılı Bilgi
                </span>
              </div>
            </li>
            <li
              class="no-campaign"
              *ngIf="!campaignsLoading && campaigns.length === 0"
            >
              <img src="../../../assets/images/logo-dark.svg" alt="" />
              <span
                >Şu an için size uygun bir indirim bulunmuyor ama bizi takipte
                kalın!</span
              >
            </li>
            <li class="loader-container" *ngIf="campaignsLoading">
              <app-loader></app-loader>
            </li>
          </ul>
        </div>
        <!-- Old Items Start -->
        <ul class="tabs">
          <li
            *ngFor="let item of oldItemsTabs"
            [class.active]="item.active"
            (click)="changeOldItemsTab(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- <div class="search-area">
    <input type="text" placeholder="Kampanya / Firma Adı İle Ara" [(ngModel)]="filterText" />
    <img class="search-icon" src="../../../assets/images/search-icon.svg" alt="" />
  </div> -->
        <div class="search-filter-area" *ngIf="oldItemsFilters">
          <!-- <div class="form-control-holder">
      <select [(ngModel)]="oldItemsFilterSector">
        <option value="">Sektör Seçiniz</option>
        <option
          *ngFor="let item of oldItemsFilters.sectors"
          [value]="item._id"
        >
          {{ item.name }}
        </option>
      </select>
    </div> -->
          <!-- <div class="form-control-holder">
      <select [(ngModel)]="filterCity">
        <option value="">İl Seçiniz</option>
        <option *ngFor="let item of filters.cities" [value]="item.name">
          {{ item.name }}
        </option>
      </select>
    </div>
    <div class="form-control-holder">
      <select [(ngModel)]="filterTown" [disabled]="!filterCity">
        <option value="">İlçe Seçiniz</option>
        <option *ngFor="let item of filtersTowns" [value]="item.name">
          {{ item.name }}
        </option>
      </select>
    </div> -->
        </div>
        <div class="results-area old-items-results-area">
          <ul>
            <li
              *ngFor="let item of filteredOldItemsCampaigns"
              routerLink="/{{ item.companySlugUrl }}/{{
                item.slugUrl || item.formId
              }}"
              style="opacity: 0.4"
            >
              <div class="logo-holder">
                <div
                  class="campaign-logo-bg"
                  *ngIf="item.logo"
                  style="background-image: url('{{ item.logo }}')"
                ></div>
                <div
                  class="campaign-logo-bg"
                  *ngIf="!item.logo"
                  style="
                    background-image: url('../../../assets/images/logo-dark.svg');
                  "
                ></div>
              </div>
              <div class="content-holder">
                <div class="cta-top">
                  {{ item.sectorName }} <br />
                  {{ cityTownName(item) }}
                </div>
                <span
                  ><b>{{ item.name }}</b></span
                >
                <div class="cta-holder">
                  <app-button
                    type="simple"
                    text="Kazanmaya Başla!"
                  ></app-button>
                </div>
              </div>
              <div class="discount-holder">
                <app-button
                  *ngIf="item.discountType !== 'Hediye'"
                  type="curvy"
                  text="{{ item.discountAmount }} {{
                    item.discountAmountType
                  }} indirim"
                ></app-button>
                <app-button
                  *ngIf="item.discountType === 'Hediye'"
                  [type]="getGiftFontClass(item)"
                  text="{{ item.discountDescription?.trim() }}"
                ></app-button>
              </div>
              <div class="last-date-holder">
                <span
                  class="last-date-text"
                  *ngIf="item.campaignExpireDateTime"
                >
                  Kampanya Geçerlilik Tarihi:
                  {{ item.createdOn | date : "dd.MM.yyyy" }} –
                  {{ item.campaignExpireDateTime | date : "dd.MM.yyyy" }}
                </span>
                <span class="last-date-text last-date-info-text">
                  Ayrıntılı Bilgi
                </span>
              </div>
            </li>
            <li
              class="no-campaign"
              *ngIf="
                !oldItemsCampaignsLoading && oldItemsCampaigns.length === 0
              "
            >
              <img src="../../../assets/images/logo-dark.svg" alt="" />
              <span>Geçmiş fırsat bulunamadı...</span>
            </li>
            <li class="loader-container" *ngIf="oldItemsCampaignsLoading">
              <app-loader></app-loader>
            </li>
          </ul>
          <app-button
            type="bold"
            text="Daha Fazla Göster"
            (click)="oldItemsShowAll = true"
            class="old-items-show-more-button"
            *ngIf="
              oldItemsCampaigns.length > 3 &&
              !oldItemsCampaignsLoading &&
              !oldItemsShowAll
            "
          ></app-button>
        </div>
      </ng-template>
    </div>
  </section>
  <section>
    <app-brand-reviews></app-brand-reviews>
  </section>
  <section style="border-top: 10px solid #f39200">
    <app-customer-reviews></app-customer-reviews>
  </section>
</div>

<!-- <app-home-video-modal></app-home-video-modal> -->
